import script from "./ConnectWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectWallet.vue?vue&type=script&setup=true&lang=js"

import "./ConnectWallet.vue?vue&type=style&index=0&id=2808e04a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2808e04a"]])

export default __exports__